module.exports = __webpack_public_path__ + "media/images/list_practice/6-01-bddaff8366432e62be2f94956caeb1fe.svg";